/**
 * @fileoverview Which tags SELECT contacts for a contact-role fan-out
 * template (MOR-2342 BKY-10).
 *
 * Job-role (`cr:*`), job-custom-role (`jcr:*`), firm-category (`fc:*`) and
 * firm-custom-category (`fcc:*`) tags each choose contacts. Address-state
 * tags (`fcs:*`, MOR-913) NARROW a firm-contact selection; they only ever
 * act as a selector on their own when the template has no other selector
 * at all. A template tagged "Bankrupt + NSW" therefore fans out to the
 * bankrupt only — it must never broaden into every firm contact in NSW.
 */

export interface FanOutTagCounts {
  jobRoles: number;
  jobCustomRoles: number;
  firmCategories: number;
  firmCustomCategories: number;
  firmStates: number;
}

/** True when at least one tag of any kind can select or narrow contacts. */
export function hasAnyFanOutTag(counts: FanOutTagCounts): boolean {
  return (
    counts.jobRoles > 0 ||
    counts.jobCustomRoles > 0 ||
    counts.firmCategories > 0 ||
    counts.firmCustomCategories > 0 ||
    counts.firmStates > 0
  );
}

/**
 * True only for a template whose ONLY tags are address states: then the
 * states select firm contacts directly. Any job-role or firm-category tag
 * turns the states back into a filter on the firm-category selection.
 */
export function firmStatesSelectOnTheirOwn(counts: FanOutTagCounts): boolean {
  return (
    counts.firmStates > 0 &&
    counts.jobRoles === 0 &&
    counts.jobCustomRoles === 0 &&
    counts.firmCategories === 0 &&
    counts.firmCustomCategories === 0
  );
}
